import { useState } from "react";

/* PACKAGES */
import PhoneInput from "react-phone-number-input";
import * as yup from "yup";
import { toast } from "sonner";

/* MATERIAL TAILWIND COMPONENTS */
import { Button } from "@material-tailwind/react";

/* FORM HANDLER */
import { useFormik } from "formik";

/* API */
import { postContactUsApi } from "service/api/contact.api";
import { useNavigate } from "react-router-dom";

const validationSchemaForContactUs = yup.object().shape({
  firstName: yup.string().required("First Name is required."),
  email: yup.string().required("Email is required."),
  phoneNumber: yup.string().required("Phone Number is required."),
  lastName: yup.string().required("Last Name is required."),
});

const ContactForm = () => {
  const navigate = useNavigate();

  /* STATE VARIABLES */
  const [loading, setLoading] = useState(false);

  /* FORM HANDLER */
  const formHandling = useFormik({
    initialValues: {
      firstName: "",
      email: "",
      phoneNumber: "",
      lastName: "",
    },
    validationSchema: validationSchemaForContactUs,
    onSubmit: (values) => {
      setLoading(true);
      postContactUsApi(values)
        .then((res) => {
          if (res?.status) {
            navigate("/thank-you");
            formHandling.handleReset();
          } else {
            toast.error(res.message);
          }
        })
        .catch((e) => {
          if (e?.message === "Network Error") {
            toast.error(e?.message);
          } else {
            console.log("ERROR", e?.response?.data?.message);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <form
      className="w-full xl:w-11/12 lg:w-11/12 ml-auto"
      onSubmit={formHandling.handleSubmit}
    >
      <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-5">
        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
          <label className="text-sm font-source font-normal text-white text-opacity-70">
            First name <span className="text-red-400">*</span>
          </label>
          <div className="mt-1">
            <input
              type="text"
              name="firstName"
              id="firstName"
              placeholder="First name"
              className={`w-full block bg-white bg-opacity-20 px-4 py-2 rounded-md text-white outline-none focus:outline-none text-sm font-source font-medium placeholder:text-white placeholder:text-opacity-30 placeholder:font-source border ${
                formHandling.errors.firstName && formHandling.touched.firstName
                  ? "border-red-400"
                  : "border-transparent"
              }`}
              value={formHandling.values.firstName}
              onChange={formHandling.handleChange}
            />
          </div>
        </div>
        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
          <label className="text-sm font-source font-normal text-white text-opacity-70">
            Last name <span className="text-red-400">*</span>
          </label>
          <div className="mt-1">
            <input
              type="text"
              name="lastName"
              id="lastName"
              placeholder="Last name"
              className={`w-full block bg-white bg-opacity-20 px-4 py-2 rounded-md text-white outline-none focus:outline-none text-sm font-source font-medium placeholder:text-white placeholder:text-opacity-30 placeholder:font-source border ${
                formHandling.errors.lastName && formHandling.touched.lastName
                  ? "border-red-400"
                  : "border-transparent"
              } `}
              value={formHandling.values.lastName}
              onChange={formHandling.handleChange}
            />
          </div>
        </div>
        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
          <label className="text-sm font-source font-normal text-white text-opacity-70">
            Email address <span className="text-red-400">*</span>
          </label>
          <div className="mt-1">
            <input
              type="email"
              name="email"
              id="email"
              value={formHandling.values.email}
              onChange={formHandling.handleChange}
              placeholder="Email address"
              className={`${
                formHandling.errors.email && formHandling.touched.email
                  ? "w-full block bg-white bg-opacity-20 px-4 py-2 rounded-md text-white outline-none focus:outline-none text-sm font-source font-medium placeholder:text-white placeholder:text-opacity-30 placeholder:font-source border border-[#E63A27]"
                  : "w-full block bg-white bg-opacity-20 px-4 py-2 rounded-md text-white outline-none focus:outline-none text-sm font-source font-medium placeholder:text-white placeholder:text-opacity-30 placeholder:font-source border border-transparent"
              } `}
            />
          </div>
        </div>
        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
          <label className="text-sm font-source font-normal text-white text-opacity-70">
            Phone <span className="text-red-400">*</span>
          </label>
          <div className="mt-1">
            <PhoneInput
              placeholder="Phone"
              defaultCountry="US"
              className={
                formHandling.errors.phoneNumber &&
                formHandling.touched.phoneNumber
                  ? "phone-error"
                  : "phone"
              }
              value={formHandling.values.phoneNumber}
              onChange={(e) => {
                formHandling.setFieldValue("phoneNumber", e);
              }}
            />
          </div>
        </div>
      </div>
      <Button
        type="submit"
        disabled={loading}
        className="w-full xl:w-fit lg:w-fit mt-5 bg-primary hover:bg-opacity-70 text-sm font-source font-medium text-white normal-case px-5 py-3 transition-all duration-300 ease-in-out"
      >
        {loading ? "Please wait..." : "Submit"}
      </Button>
    </form>
  );
};

export default ContactForm;
